import { userService } from '@/common/api.service'
import Axios from 'axios'
import { userTypes } from '@/constants/userTypes'

const initialStates = {
    status: 'loading',
    user_status: 'loading',
    current_user: {},
    user: {},
    usersList: [],
    refererList: [
        {
        full_name: '',
        hashid: 0,
        phone: null
        }
    ],
    transactionStatistics: {},
    activitiesLogs : {},
    namad_error: {},
    usersListStatus: 'loading',
    new_user: {},
    has_two_factor_auth: false,
    token_expiry_time: null,
    two_factor_type: null,
    is_g2fa_active: false,
    currentDevice: null,
    devices: [],
    dataCount: {},
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, current_user) {
        state.status       = 'success'
        state.user_status       = 'success'
        state.current_user = current_user
    },
    fail(state) {
        state.status       = 'fail'
        state.current_user = {}
    },
    setAuthenticatePending(state) {
        state.current_user.is_authenticated_pending = true;
        state.current_user.is_authenticated         = false;
    },
    userFindSuccess(state, user) {
        state.status = 'success'
        state.user = user
    },
    userShebaNumbers(state, sheba_numbers) {
        state.status = 'success'
        state.user.sheba_numbers = sheba_numbers
    },
    usersList(state, users) {
        state.status = 'success'
        state.usersListStatus = 'success'
        state.usersList = users
    },
    refererList(state, referers) {
        state.status = 'success'
        state.refererList = referers
    },
    transactionStatistics(state, transactionStatistics) {
        state.status = 'success'
        state.transactionStatistics = transactionStatistics
    },
    activitiesLogs(state, activityLogs) {
        state.status = 'success'
        state.activitiesLogs = activityLogs
    },
    userSetting(state , userSetting) {
        state.has_two_factor_auth = userSetting.has_two_factor_auth;
        state.token_expiry_time = userSetting.token_expiry_time;
        state.two_factor_type = userSetting.two_factor_type;
        state.is_g2fa_active = userSetting.is_g2fa_active;
    },
    userDevices(state , userDevices){
        state.currentDevice = userDevices.currentDevice;
        state.devices = userDevices.devices;
    },
    userDataCount(state, dataCount) {
        state.dataCount = dataCount
    }
}

const getters = {
    current_user: ({current_user}) => current_user,
    status: ({status}) => status,
    user_status: ({user_status}) => user_status,
    usersListStatus: ({usersListStatus}) => usersListStatus,
    is_authenticated: ({current_user}) => current_user.is_authenticated || false,
    is_authenticated_pending: ({current_user}) => current_user.is_authenticated_pending || false,
    profile_completed: ({current_user}) => {
        if (current_user.user_type == userTypes.LEGAL) {
            return current_user.username
                && current_user.email
                && current_user.phone
                && current_user.telephone
                && current_user.com_name_fa
                && current_user.com_name_en
                && current_user.national_legal_code
                && current_user.register_number
                && current_user.register_date
                && current_user.signature_holder
                && current_user.signature_holder.first_name_fa
                && current_user.signature_holder.last_name_fa
                && current_user.signature_holder.father_name_fa
                && current_user.signature_holder.first_name_en
                && current_user.signature_holder.last_name_en
                && current_user.signature_holder.father_name_en
                && current_user.signature_holder.national_code
                && current_user.signature_holder.birth_date
                && current_user.technical_agent
                && current_user.technical_agent.first_name
                && current_user.technical_agent.last_name
                && current_user.technical_agent.phone_number
                && current_user.technical_agent.telephone_number
                && current_user.technical_agent.email
                && current_user.social_network;
        }

        return current_user.username
            && current_user.first_name
            && current_user.first_name_en
            && current_user.father_name
            && current_user.father_name_en
            && current_user.last_name
            && current_user.social_network
            && current_user.last_name_en
            && current_user.birth_date
            && current_user.telephone
            && current_user.national_code
            && current_user.email ? true : false
    },
    is_current_user_fetched: ({current_user}) => current_user.username !== undefined,
    user: ({user}) => user,
    sheba_numbers: ({user}) => user.sheba_numbers,
    usersSelectable: ({usersList}) => usersList,
    referersList: state => state.refererList,
    transactionStatistics: state => state.transactionStatistics,
    activitiesLogs: state =>state.activitiesLogs,
    new_user: state => state.new_user,
    has_two_factor_auth: state => state.has_two_factor_auth,
    token_expiry_time: state => state.token_expiry_time,
    two_factor_type: state => state.two_factor_type,
    is_g2fa_active: state => state.is_g2fa_active,
    currentDevice: state => state.currentDevice,
    devices: state => state.devices,
    dataCount: state => state.dataCount,
}

const actions = {
    fetchCurrent({commit}) {
        commit('loading')
        return userService.current().then(response => {
            commit('success', response.data.data)
            localStorage.setItem('exp_token', response.data.data.exp_token)
        }).catch(error => {
            localStorage.removeItem('access_token')
            delete Axios.defaults.headers.common['Authorization']
        })
    },
    fetchByHashId({commit}, hashid) {
        commit('loading')
        return userService.find(hashid).then(
            response => {
                commit('userFindSuccess', response.data.data)
            }
        )
    },
    fetchShebaNumbers({commit, state}) {
        commit('loading')
        return userService.fetchShebaNumbers(state.user.id).then(
            response => {
                commit('userShebaNumbers', response.data.data)
            }
        )
    },
    fetchForSelect({commit}) {
        commit('loading')
        return userService.fetchForSelect().then(
            response => {
                commit('usersList', response.data.data)
            }
        )
    },
    fetchReferers({commit}) {
        commit('loading')
        return userService.fetchReferers().then(
            response => {
                commit('refererList', response.data.data)
            }
        )
    },
    fetchTransactionStatistics({commit},hashid) {
        commit('loading')
        return userService.fetchTransactionStatistics(hashid).then(
            response => {
                commit('transactionStatistics', response.data.data)
            }
        )
    },
    fetchActivitiesLogs({commit}, hashid) {
        commit('loading')
        return userService.fetchActivitiesLogs(hashid).then(
            response => {
                commit('activitiesLogs', response.data.data)
            }
        )
    },
    fetchUserSetting({commit}){
        commit('loading')
        return userService.getUserSetting()
            .then(
                response => {
                    commit('userSetting' , response.data.data)
                }
            )
    },
    fetchUserDevices({commit}){
        commit('loading')
        return userService.getUserDevices()
            .then(
                response => {
                    commit('userDevices' , response.data.data)
                }
            )
    },
    updateUserSetting({commit} , formData){
        commit('loading')
        return userService.userSetting(formData)
            .then(
                () => {
                    commit('userSetting' , formData)
                }
            )
    },
    deleteUserDevice({commit} , id) {
        return userService.deleteUserDevice(id)
    },
    fetchUserG2fa({commit}) {
        return userService.fetchUserG2fa()
    },
    countData({commit}) {
        return userService.userCountData().then(
            response => {
                commit('userDataCount', response.data.data);

            }

        )
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}
